/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod/v4";

export const liveContactResearchPathParamsSchema = z.object({
    "id": z.string().describe("Contact id")
    })

export const liveContactResearchQueryParamsSchema = z.object({
    "idType": z.optional(z.enum(["internal", "external"]).describe("Identifier type (default internal)"))
    }).optional()

export const liveContactResearch200Schema = z.any()

export const liveContactResearchQueryResponseSchema = z.lazy(() => liveContactResearch200Schema)